import React from "react";
import LivePage from "./LivePage";

/**
 * LegoAdminPageContext - A context for the LegoAdminPage component
 * @type {React.Context<{user: Object, page?: LivePage}>}
 */
const LegoAdminPageContext = React.createContext({ user: 'tenemos un problema'});

export default LegoAdminPageContext;
